<template lang="html">
  <div id="home-page">

    <section class="banner-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-lg-6 col-content">
            <h2 class="title">Operadores B1<br />Mexico - USA</h2>
            <p>
              Súmate al equipo de Marquez Express.
            </p>
            <p class="mt-2">
              Ofrecemos $0.45 USD por milla y capacitación continua para tu crecimiento profesional.
            </p>

            <p class="mt-3">
              <router-link class="btn _btn" to="/registro">Aplica en línea</router-link>
            </p>
          </div>

          <div class="col-lg-6 col-xl-5 offset-xl-1 col-image">
            <div class="image">
              <img src="public/images/pages/home/banner-1.jpg">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="benefits-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">Beneficios</h2>
          </div>

          <div class="col-sm-6 col-lg-3 col-benefit">
            <div class="b-icon">
              <div class="mb-3 mx-auto circle">
                <i class="fa-regular fa-credit-card-blank i-small"></i>
              </div>
            </div>

            <h6 class="title">Diesel Card</h6>
            <p>
              Tarjeta de combustible para todos tus viajes.
            </p>
          </div>

          <div class="col-sm-6 col-lg-3 col-benefit">
            <div class="b-icon">
              <div class="mb-3 mx-auto circle">
                <i class="fa-regular fa-clock"></i>
              </div>
            </div>

            <h6 class="title">Road Service 24/7</h6>
            <p>
              Asistencia en carretera disponible todo el tiempo.
            </p>
          </div>

          <div class="col-sm-6 col-lg-3 col-benefit">
            <div class="b-icon">
              <div class="mb-3 mx-auto circle">
                <i class="fa-regular fa-credit-card i-small"></i>
              </div>
            </div>

            <h6 class="title">Pago Inmediato</h6>
            <p>
              Recibe tu pago justo después de completar el viaje.
            </p>
          </div>

          <div class="col-sm-6 col-lg-3 col-benefit">
            <div class="b-icon">
              <div class="mb-3 mx-auto circle">
                <i class="fa-regular fa-circle-dollar"></i>
              </div>
            </div>

            <h6 class="title">Bono de Contratación</h6>
            <p>
              Contratación inmediata y bono de bienvenida.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="extra-benefits-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">Más beneficios</h2>
          </div>

          <div class="col-sm-6 col-lg-3 col-ebenefit">
            <div class="box-icon">
              <img src="public/images/pages/home/icon-1.svg">
            </div>

            <h5 class="title">Clases de ingles</h5>
          </div>

          <div class="col-sm-6 col-lg-3 col-ebenefit">
            <div class="box-icon">
              <img src="public/images/pages/home/icon-2.svg">
            </div>

            <h5 class="title">Descansos programados</h5>
          </div>

          <div class="col-sm-6 col-lg-3 col-ebenefit">
            <div class="box-icon">
              <img src="public/images/pages/home/icon-3.svg">
            </div>

            <h5 class="title">Excelente ambiente de trabajo</h5>
          </div>

          <div class="col-sm-6 col-lg-3 col-ebenefit">
            <div class="box-icon">
              <img src="public/images/pages/home/icon-4.svg">
            </div>

            <h5 class="title">Cargos de Droops and Hooks</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="requirements-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">Requisitos Básicos</h2>
          </div>

          <div class="col-sm-8 col-md-6 col-lg-5 col-xl-4 col-reqs mx-auto">
            <ul>
              <li>
                <p>Pasaporte mexicano vigente</p>
              </li>
              <li>
                <p>Visa B1 válida</p>
              </li>
              <li>
                <p>Licencia Federal de Conductor Tipo B1</p>
              </li>
              <li>
                <p>Mínimo 3 años de experiencia</p>
              </li>
            </ul>

            <p class="mt-4 text-center">
              <router-link class="btn btn-s1 bg-1" to="/registro">Aplicar ahora</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
